import React, { useState, useEffect } from 'react';
import { ScrollView } from 'react-native';
import Text from '../../components/styled/Text';
import View from '../../components/styled/View';
import FeedbackCard from '../../components/styled/FeedbackCard';
import SessionCard from '../../components/styled/SessionCard';
import client from '../../../graphql/client';
import styles from './styles';
import HeaderOne from '../../components/styled/HeaderOne';
export default function ArtistSessionResultsScreen({ navigation, route }) {
  const sessionId = route.params.sessionId;
  const [session, setSessionInfo] = useState<any>(null);

  const getSessionInfo = async () => {
    const rawSession = await client.getASession(sessionId);
    setSessionInfo(rawSession);
  };

  useEffect(() => {
    //if (session) return null;
    getSessionInfo();
  }, []);

  if (!session) return null;

  return (
    <ScrollView>
      <View style={styles.container}>
        <HeaderOne style={styles.title} title="Session Results For:" />
        <SessionCard isDashboard={false} session={session} />
        <View
          style={styles.separator}
          lightColor="#eee"
          darkColor="rgba(255,255,255,0.1)"
        />
        <FeedbackCard session={session} />
      </View>
    </ScrollView>
  );
}
